<template>
  <section>
    <section class="page1 wow fadeInUpBig" data-wow-duration="2s" data-wow-delay="0s">
      <article class="container">
        <wl-title class="h1" title='为什么要进行产品合作' :isNeedDesc=false></wl-title>
        <section class="img"><img class="wow flipInX" data-wow-duration="2s" data-wow-delay="0s" v-lazy="'/static/img/cooperate/2-img1.png'" alt="突破局限 打破传统模式"></section>
        <section class="flexWrap">
          <section class="box" v-for="item in page1Data" :key="item.key">
            <h3>{{item.title}}</h3>
            <p>{{item.desc}}</p>
          </section>
        </section>
      </article>
    </section>
    <section class="page2">
      <article class="container">
        <wl-title title='合作画像' :isNeedDesc=false class="wow fadeInUpBig title" data-wow-duration="2s" data-wow-delay="0s"></wl-title>
        <section class="flexWrap wow fadeInUpBig" data-wow-duration="2s" data-wow-delay="0s">
          <section class="left">
            <section class="top flexColumn">
              <section class="_icon"></section>
              <h3>伙伴画像</h3>
            </section>
            <h3 class="bott">合作项目</h3>
          </section>
          <section class="box" v-for="item in page2Data" :key="item.key">
            <section class="img">
              <h3>{{item.desc}}</h3>
              <img v-lazy="'/static/img/cooperate/'+item.key+'.png'" :alt="item.desc">
            </section>
            <h3 class="bott">{{item.title}}</h3>
          </section>
        </section>
      </article>
    </section>
    <section class="page3 bg" v-lazy:background-image="'/static/img/cooperate/1-bg1.png'">
      <article class="container">
        <wl-title title='为什么选择米联物联进行合作' :isNeedDesc=false class="wow fadeInUpBig title" data-wow-duration="2s" data-wow-delay="0s"></wl-title>
        <section class="flexWrap wow fadeInUpBig" data-wow-duration="2s" data-wow-delay="50ms">
          <section v-for="(item,idx) in page3Data" :key="item.key" class="fl_box">
            <section class="_icon " :style="`background-position: -${92*idx}px -116px;`"></section>
            <h3>{{item.title}}</h3>
            <p>{{item.desc}}</p>
          </section>
        </section>
      </article>
    </section>
    <section class="page4">
      <article class="container">
        <wl-title title='合作流程' :isNeedDesc=false class="wow fadeInUpBig title" data-wow-duration="2s" data-wow-delay="0s"></wl-title>
        <section class="img"><img class="wow fadeInUpBig" data-wow-duration="2s" data-wow-delay="0s" v-lazy="'/static/img/cooperate/2-img5.png'" alt="提交申请，合作洽谈，签订协议"></section>
      </article>
    </section>
    <contact-page></contact-page>
  </section>
</template>

<script>
import contactPage from './contactPage.vue'
import WOW from 'wowjs'
export default {
  components: { contactPage },
  name: 'business',
  data() {
    return {
      page1Data: [
        { title: '产品', desc: '让您的产品打破固有模式，兼容性更高、 更加智能化、信息化' },
        { title: '方案', desc: '让您的方案更加丰富，更具有市场差异化特点' },
        { title: '受众', desc: '让您的客户群体范围更广，适用更多的应用场景' },
        { title: '市场', desc: '让您的营销模式更灵活，市场贴合实际需求更具市场竞争力' },
      ],
      page2Data: [
        { title: '危化品管理系统', desc: '智能试剂柜厂商', key: '2-img2' },
        { title: '生物样本库管理系统', desc: '生物样本库硬件厂商', key: '2-img3' },
        { title: 'LIMS数据采集系统', desc: '离心机厂商', key: '2-img4' },
      ],
      page3Data: [
        { title: '更多厂商的选择', desc: '某著名法国净化柜品牌、迈瑞医疗等客户安全之选', key: 'cooperate2-2' },
        { title: '产品齐全', desc: '产品齐全功能强大，能满足不同类型伙伴需求', key: 'cooperate2-3' },
        { title: '强大的研发实力', desc: '拥有核心技术及专业的研发团队\n持续不断的更新产品及为用户提供运维服务', key: 'cooperate2-4' },
        { title: '专注做实验室信息化建设', desc: '拥有10年实验室信息化服务经验，对实验室业务需\n求深入理解能够提供贴合实际市场需求的解决方案', key: 'cooperate2-5' },
      ],
    }
  },
  mounted() {
    new WOW.WOW({ live: false }).init()
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
._icon {
  background: url("/static/img/cooperate/icon-sprite1.png");
}
p {
  white-space: pre-line;
  font-size: 24px;
  color: #8e8e8e;
}
h3 {
  color: #262626;
  line-height: 28px;
  font-size: 28px;
  font-weight: 500;
}
.page1 {
  overflow: hidden;
  height: 1012px;
  padding-top: 136px;
  position: relative;
  .h1 {
    padding-bottom: 65px;
  }
  .img {
    width: 429px;
    position: absolute;
    left: 50%;
    top: 52%;
    transform: translate(-50%, -50%);
  }
  .box {
    width: 384px;
    text-align: left;
    &:nth-child(1) {
      margin-right: 200px;
    }
    &:nth-child(3) {
      padding-top: 176px;
    }
    &:nth-child(4) {
      padding-top: 176px;
    }
    h3 {
      padding-bottom: 16px;
    }
    p {
      color: #6d6d6d;
      line-height: 36px;
      padding-top: 30px;
      border-top: 3px solid #308dff;
    }
  }
}
.page2 {
  overflow: hidden;
  height: 812px;
  background: #f6f9ff;
  .title {
    padding-top: 136px;
  }
  .img {
    width: 312px;
    position: relative;
    h3 {
      position: absolute;
      color: #fff;
      font-weight: bold;
      width: 100%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .flexWrap {
    padding-top: 65px;
  }
  .img::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #999999;
    opacity: 0.6;
    transition: all 0.2s linear;
  }
  h3 {
    font-size: 30px;
    line-height: 30px;
  }
  .bott {
    margin-top: 8px;
    background: #ebf4ff;
    height: 159px;
    padding-top: 60px;
    font-weight: 400;
  }
  .left {
    width: 307px;
    .top {
      height: 269px;
      background: #ebf4ff;
      ._icon {
        width: 84px;
        height: 84px;
        margin-bottom: 28px;
        background-position: 0px -32px;
        display: inline-block;
      }
    }
  }
  .box {
    &:hover {
      .img::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #308dff;
        opacity: 0.35;
      }
    }
    .bott {
      background: #fff;
    }
  }
}
.page3 {
  overflow: hidden;
  height: 1055px;
  .title {
    padding-top: 136px;
  }
  ._icon {
    width: 92px;
    height: 92px;
    transition: all 0.2s linear;
    display: inline-block;
  }
  .flexWrap {
    margin-top: 33px;
    .fl_box {
      width: 613px;
      height: 323px;
      background: #ffffff;
      border-radius: 14px;
      padding-top: 66px;
      transition: all 0.2s linear;
      margin-top: 32px;
      &:nth-child(3) {
        padding-top: 50px;
      }
      &:nth-child(4) {
        padding-top: 50px;
      }
      &:hover {
        ._icon {
          transform: translateY(-8px);
        }
      }
      h3 {
        padding-top: 13px;
        padding-bottom: 18px;
      }
      p {
        font-size: 18px;
        line-height: 28px;
      }
    }
  }
}
.page4 {
  overflow: hidden;
  height: 585px;
  .title {
    padding-top: 136px;
  }
  .img {
    width: 1260px;
    margin-top: 65px;
  }
}
</style>
